import React from 'react'
import ChatUI from './ChatUI'

export default function index(props) {
  return (
    <ChatUI {...props} />
  )
}
